var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#164B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.92563 10.5007L7.57519 11.2489H6.79781L8.90888 6.75L10.3168 9.74981H9.52088L8.89088 8.44762L8.25975 9.77175L7.92563 10.5007ZM10.9935 11.232L12.6416 9.01012L10.9817 6.77138H11.8901L13.0944 8.40825L12.6563 9.01012L13.0944 9.612L11.8907 11.2489H10.224L9.87188 10.5007H10.6493L10.9935 11.232ZM13.5394 9.00056L13.0944 8.38912L14.2988 6.75225H15.1875L13.5394 9.00056ZM13.5394 9.00056L15.1875 11.2494H14.2988L13.095 9.61256L13.5394 9.00056ZM6.42488 7.40194C6.6269 7.61517 6.78482 7.86622 6.88955 8.14065C6.99429 8.41509 7.04378 8.70751 7.03519 9.00113C7.0429 9.5923 6.8246 10.1641 6.42488 10.5998C6.01875 11.0548 5.51644 11.25 4.92413 11.25C4.64238 11.2528 4.36319 11.1964 4.10466 11.0843C3.84612 10.9723 3.61401 10.8072 3.42338 10.5998C3.01713 10.1681 2.79761 9.59366 2.8125 9.00113C2.80345 8.5372 2.93932 8.082 3.20119 7.69894L3.71869 8.25019C3.55668 8.53926 3.48921 8.87179 3.52573 9.20115C3.56224 9.53051 3.70092 9.84018 3.92231 10.0867C4.04778 10.2288 4.20181 10.3429 4.37434 10.4214C4.54687 10.4999 4.73402 10.5411 4.92356 10.5424C5.30156 10.5424 5.66269 10.3776 5.92481 10.0867C6.05927 9.94448 6.16439 9.77712 6.23417 9.59423C6.30395 9.41134 6.33702 9.21649 6.3315 9.02081C6.33281 8.62709 6.18765 8.24695 5.92425 7.95431C5.79818 7.81453 5.64352 7.70351 5.47077 7.62878C5.29801 7.55405 5.11119 7.51735 4.923 7.52119C4.67431 7.51436 4.42937 7.583 4.22044 7.71806L3.70294 7.16681C4.05046 6.89203 4.48227 6.74577 4.92525 6.75281C5.20697 6.74778 5.4865 6.8031 5.74506 6.91507C6.00363 7.02703 6.23523 7.19304 6.42431 7.40194H6.42488Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOax);
export default __webpack_public_path__ + "static/media/oax.6035b17d3b54142c919132d696f2e3c0.svg";
export { ForwardRef as ReactComponent };